import React from 'react';
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import { formatDateLocale } from '../../../../../lib/utils.es6';

export function DisplayClaims({ currencyCode, classes, setSelectedClaims, selectedClaims, setShowNothingSelectedError, pagingData, getClaims }) {

  const getClaimss = (payload) => {
    getClaims(payload);
  }

  const claimsFormatted = selectedClaims.map(claim => {
    return {
      ...claim,
      grower_number: claim.claim_details.policy_number
    }
  })


  const claimDateValue = (claim) => {
    switch (claim.status) {
      case "All_Docs_Pending":
      case "Docs_Partially_Submitted":
        return claim.created_at;
      case "Awaiting_Confirmation":
        return claim.documentation_received_at;
      case "Failed_Confirmation":
        return claim.updated_at;
      case "Decision_Pending":
        return claim.updated_at;
      case "Approved":
        return claim.decision_made_at;
      default:
        return claim.created_at;
    }
  };

  const claimDateLabel = () => {
    const claim = claimsFormatted[0];

    if (!claim) return "Created At";

    switch (claim.status) {
      case "All_Docs_Pending":
      case "Docs_Partially_Submitted":
        return "Created At";
      case "Awaiting_Confirmation":
        return "Doc submitted at";
      case "Failed_Confirmation":
        return "Failed at";
      case "Decision_Pending":
        return "Confirmed at";
      case "Approved":
        return "Approved At";
      default:
        return "Created At";
    }
  };

  return <Grid container spacing={2}>
    <Grid item xs={12} md={12} sm={12}>
      <TableInc
        columns={[
          { title: 'Claim number', field: 'claim_number', render: rowData => rowData.claim_number || "N/A" },
          { title: 'status', field: 'status', render: rowData => rowData.status || "N/A" },
          { title: 'Policy  Number', field: 'grower_number'  },
     
          { title: 'Payable Amount', field: 'benefit_usages', render: rowData => `${currencyCode} ${(rowData.benefit_usages.reduce((psum, benefit) => psum + benefit.benefit_amount_in_cents, 0) / 100).toLocaleString()}` || "N/A" },
          { title: claimDateLabel(), render: rowData => formatDateLocale(claimDateValue(rowData)) || "N/A" },
          { title: 'action', field: 'claimaction', render: rowData => {
              return <div className={classes.claimactionbt}>
                <ButtonInc
                  onClick={() => hashHistory.push(`admin/claim-processing-v2/${rowData.guid}`)}

                  variant="contained">View Claim</ButtonInc>
              </div>;
            }
          },
        ]}

        data={(query) =>
          new Promise((resolve, reject) => {
            resolve({
              data: claimsFormatted,
              page: pagingData.page - 1,
              totalCount: pagingData.total,
            });
          })
        }
        options={{
          showTitle: false,
          pageSizeOptions: [1, 5, 10, 20, 50, 100],
          pageSize: pagingData.size,
          selection: true,
          selectionProps: rowData => ({
            color: 'primary',
          }),
          rowStyle: rowData => ({
            backgroundColor: rowData.selected ? '#ffe2ec' : '#FFF'
          }),
        }}
        onChangeRowsPerPage={(pageSize) => {
          console.log(pageSize, "pageSize");
          getClaimss({ page: pagingData.page, size: pageSize });
        }}
        onChangePage={(page) => {
          console.log(page, "page");
          getClaimss({ page: page + 1, size: pagingData.size });
        }}


        onSelectionChange={(rows) => {
          setSelectedClaims(claimsFormatted.map(item => rows.find(row => row.guid === item.guid) ? { ...item, selected: true } : { ...item, selected: false }));
          setShowNothingSelectedError(false)
        }}

        localization={{
          toolbar: {
            nRowsSelected: '{0} claim(s) selected'
          }
        }}


      />

    </Grid>
  </Grid>;
}
